import { ColDef, GridOptions, ICellRendererParams, RowDoubleClickedEvent } from 'ag-grid-community';
import React from 'react';
import { isNull } from 'lodash/fp';

import { useAppDispatch, useAppSelector } from '../../../hooks/react-redux';
import { Icon } from '../../shared/icon/Icon';
import { LongText, Pencil } from '../../shared/icons';
import { Table } from '../../shared/table';
import styles from './DocumentName.module.scss';
import { getAllAdminDocumentNames, toggleModal } from './store';
import { IconTooltip } from '../../shared/tooltip';

const IconCell: React.FC<ICellRendererParams> = ({ data }) => {
    const dispatch = useAppDispatch();

    const editDocument = () => dispatch(toggleModal(true, data));
    return (
        <div className={styles.editDocumentButton} onClick={editDocument}>
            <Icon fontSize={20} icon={Pencil} />
        </div>
    );
};

const SchedulePageCell: React.FC<ICellRendererParams> = ({ data }) => (
    <div className={styles.tableIconWrapper}>
        {!isNull(data.boilerPlateEndText) && <div><IconTooltip content={`Boilder Plate End Text: ${data.boilerPlateEndText}`} icon={LongText} /></div>}
        {!isNull(data.scheduleStartText) && <div><IconTooltip content={`Schedule Start Text: ${data.scheduleStartText}`} icon={LongText} /></div>}
        {!isNull(data.scheduleEndText) && <div><IconTooltip content={`Schedule End Text: ${data.scheduleEndText}`} icon={LongText} /></div>}
    </div>
);

export const DocumentNameTable: React.FC = () => {
    const dispatch = useAppDispatch();
    const documentNames = useAppSelector(getAllAdminDocumentNames);

    const defaultCellStyle = { textAlign: 'left', fontSize: '14px' };
    const columnDefs: ColDef[] = [
        { headerName: 'Document Name', field: 'documentName', cellStyle: defaultCellStyle, width: 0.35 },
        { headerName: 'Dataset', field: 'datasetTitle', cellStyle: defaultCellStyle, width: 0.3 },
        { headerName: 'Agreement Type', field: 'agreementType', cellStyle: defaultCellStyle, width: 0.15 },
        { headerName: 'Schedule Page Text', field: 'scheduleStartText', cellRenderer: 'schedulePageTextRenderer', width: 0.15 },
        { headerName: '', field: '', cellRenderer: 'iconCellRenderer', width: 0.05 }
    ];

    const gridOptions: GridOptions = {
        components: {
            iconCellRenderer: IconCell,
            schedulePageTextRenderer: SchedulePageCell
        },
        paginationPageSize: 20
    };

    const onRowDoubleClicked = ({ data }: RowDoubleClickedEvent) => dispatch(toggleModal(true, data));

    return (
        <Table
            colDefs={columnDefs}
            rowData={documentNames}
            gridOptions={gridOptions}
            percentageWidths={true}
            onRowDoubleClicked={onRowDoubleClicked}
            testId='document-name'
        />
    );
};
